import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {Observable} from "rxjs";
import {ConversacionListado} from "../../interfaces/conversacion";
import {ListarPorCarpeta} from "../carpetas/carpetas.component";

@Injectable({
  providedIn: 'root',
})

export class ListarConversacionesService {
  private readonly conversacionUrl: string;

  constructor(private httpClient: HttpClient) {
    this.conversacionUrl = environment.apiUrl + '/shared/listar-conversaciones';
  }

  public __invoke(parametros: ListarPorCarpeta): Observable<ConversacionListado[]> {
    return this.httpClient.post<ConversacionListado[]>(this.conversacionUrl, parametros);
  }
}
